import gql from 'graphql-tag';
import { taxFragment, warehousesFragment } from '../../../../graphql/fragments';

export const WAREHOUSES_QUERY = gql`
query Warehouses($onlyCurrentVenue: Boolean = true) {
  warehouses(onlyCurrentVenue: $onlyCurrentVenue) {
      ...WarehousesFragment
    }
  }
  ${warehousesFragment}
`;

export const WAREHOUSE_QUERY = gql`
query Warehouse($id: ID!){
  warehouse(id: $id) {
    id
    name
    venueIds
  }
}
`;

export const STOCK_CARDS_QUERY = gql`
query StockCards(
    $warehouseIds: [ID!]!
    $offset: Int
    $limit: Int
    $stockCardCategoryId: ID
    $nameOrSku: String
    $stockCardsIds: [ID!]
    $storageUnit: UnitType
    $stockCardNameSortOrder: SortOrder
    $stockCardQuantitySortOrder: SortOrder
  ) {
  stockCards(
    warehouseIds: $warehouseIds
    offset: $offset
    limit: $limit
    stockCardCategoryId: $stockCardCategoryId
    nameOrSku: $nameOrSku
    stockCardsIds: $stockCardsIds
    storageUnit: $storageUnit
    stockCardNameSortOrder: $stockCardNameSortOrder
    stockCardQuantitySortOrder: $stockCardQuantitySortOrder
  ) @connection(
      key: "stockCards",
      filter: [
        "stockCardsIds","warehouseIds",
        "stockCardCategoryId",
        "nameOrSku",
        "storageUnit",
        "stockCardNameSortOrder",
        "stockCardQuantitySortOrder"
      ]
  ) {
    id
    name
    storageUnit
    conversionUnit
    convertedAmount
    sku
    taxId
    warehouses {
      id
    }
    stockCardCategory {
      id
      name
    }
    stockLevels {
      id
      quantity
      warehouseId
      priceWithoutVat
    }
    tax {
      rate
    }
  }
}
`;

export const PAGINATED_STOCK_CARDS_QUERY = gql`
query PaginatedStockCards(
  $warehouseIds: [ID!]!
  $offset: Int
  $limit: Int
  $stockCardCategoryId: ID
  $nameOrSku: String
  $stockCardsIds: [ID!]
  $storageUnit: UnitType
  $stockCardNameSortOrder: SortOrder
  $stockCardQuantitySortOrder: SortOrder
) {
  paginatedStockCards(
    warehouseIds: $warehouseIds
    offset: $offset
    limit: $limit
    stockCardCategoryId: $stockCardCategoryId
    nameOrSku: $nameOrSku
    stockCardsIds: $stockCardsIds
    storageUnit: $storageUnit
    stockCardNameSortOrder: $stockCardNameSortOrder
    stockCardQuantitySortOrder: $stockCardQuantitySortOrder
  ) @connection(
      key: "paginatedStockCards",
      filter: [
        "stockCardsIds","warehouseIds",
        "stockCardCategoryId",
        "nameOrSku",
        "storageUnit",
        "stockCardNameSortOrder",
        "stockCardQuantitySortOrder"
      ]
  ) {
    items {
      id
      name
      storageUnit
      conversionUnit
      convertedAmount
      sku
      taxId
      warehouses {
        id
      }
      stockCardCategory {
        id
        name
      }
      stockLevels {
        id
        quantity
        warehouseId
        priceWithoutVat
      }
    }
    count
  }
  stockCardCategories {
    id
    name
  }
}
`;

export const WarehouseCardFormQuery = gql`
    query WarehouseCardFormQuery($onlyCurrentVenue: Boolean = false) {
      warehouses(onlyCurrentVenue: $onlyCurrentVenue) {
        id
        name
      }
      stockCardCategories {
        id
        name
      }
      taxes {
        ...TaxesFragment
      }
    }
    ${taxFragment}
`;

export const STOCK_CARD_QUERY = gql`
  query StockCard($id: ID! $currentVenueOnly: Boolean) {
    stockCard(id: $id) {
      id
      name
      sku
      storageUnit
      conversionUnit
      convertedAmount
      taxId
      warehouses(currentVenueOnly: $currentVenueOnly) {
        id
        name
      }
      stockCardCategory {
        id
      }
      stockLevels {
        id
        warehouseId
        priceWithoutVat
      }
    }
  }
`;

export const INVENTORY_COUNTS_QUERY = gql`
query InventoryCounts($warehouseId: ID!){
  inventoryCounts(warehouseId: $warehouseId) {
    id
    startDate
    expectedValuation
    realValuation
    endDate
    deltas {
      withoutVat
    }
    shortageSurplus {
      surplus {
        withoutVat
      }
      shortage {
        withoutVat
      }
    }
  } 
}
`;

export const CURRENT_INVENTORY_COUNT_QUERY = gql`
query CurrentInventoryCount($warehouseId: ID!){
  currentInventoryCount(warehouseId: $warehouseId) {
    id
    inventoryCountItems {
      id
      expectedCount
      realCount
      stockCard {
        id
        name
        storageUnit
        conversionUnit
        stockCardCategoryId
        stockCardCategory {
          name
        }
      }
    }
  }
  stockCardCategories {
    id
    name
  }
}
`;

export const INVENTORY_COUNT_QUERY = gql`
query InventoryCount($id: ID!, $warehouseId: ID!) {
  inventoryCount(
  warehouseId: $warehouseId
  id: $id
  ) {
    id
    startDate
    endDate
    expectedValuation
    realValuation
    notMatchingCounts
    notCalculatedCounts
    deltas {
      withoutVat
    }
    shortageSurplus {
      surplus {
        withoutVat
      }
      shortage {
        withoutVat
      }
    }
  }
}
`;

export const PAGINATED_INVENTORY_COUNT_ITEMS_QUERY = gql`
query PaginatedInventoryCountItems(
  $offset: Int
  $limit: Int
  $inventoryCountId: ID!
  $stockCardCategoryId: ID
  $unmatchedOnly: Boolean
  $notCountedOnly: Boolean
  $moreThanExpectedOnly: Boolean
  $lessThanExpectedOnly: Boolean
  $stockCardNameOrSku: String
) {
  paginatedInventoryCountItems(
    offset: $offset
    limit: $limit
    inventoryCountId: $inventoryCountId
    stockCardCategoryId: $stockCardCategoryId
    unmatchedOnly: $unmatchedOnly
    notCountedOnly: $notCountedOnly
    moreThanExpectedOnly: $moreThanExpectedOnly
    lessThanExpectedOnly: $lessThanExpectedOnly
    stockCardNameOrSku: $stockCardNameOrSku
  ) @connection(
      key: "paginatedInventoryCountItems",
      filter: [
        "inventoryCountId"
        "stockCardCategoryId"
        "unmatchedOnly"
        "notCountedOnly"
        "moreThanExpectedOnly"
        "lessThanExpectedOnly"
        "stockCardNameOrSku"
      ]
    ) {
    items {
      id
      updatedById
      expectedCount
      realCount
      pricePerUnitWithoutVAT
      stockCard {
        id
        name
        storageUnit
        conversionUnit
        convertedAmount
        stockCardCategory {
          id
          name
        }
      }
    }
    count
  }
}
`;

export const STOCK_CARDS_SEARCH_QUERY = gql`
query StockCardsSearch(
  $warehouseIds: [ID!]!,
  $offset: Int,
  $limit: Int,
  $stockCardCategoryId: ID,
  $nameOrSku: String,
  $storageUnit: UnitType
) {
  stockCards(
    warehouseIds: $warehouseIds,
    offset: $offset,
    limit: $limit,
    nameOrSku: $nameOrSku,
    stockCardCategoryId: $stockCardCategoryId
    storageUnit: $storageUnit
  ) @connection(key: "stockCards", filter: [
    "warehouseIds",
    "stockCardCategoryId",
    "nameOrSku",
    "storageUnit"
  ]) {
    id
    name
    storageUnit
    conversionUnit
    warehouses {
      id
      name
    }
    stockCardCategory {
      id
      name
    }
  }
}
`;